import React from "react";
import { Drawer } from "@mui/material";
import useNoScroll from "@/hooks/useNoScroll";
import useWrapperLock from "@/hooks/useWrapperLock";

interface ReusableDrawerProps {
  open: boolean;
  onClose: () => void;
  anchor?: "left" | "right" | "top" | "bottom";
  isMobile?: boolean;
  children: React.ReactNode;

}

const ReusableDrawer: React.FC<ReusableDrawerProps> = ({
  open,
  onClose,
  anchor = "bottom",
  isMobile = false,
  children,

}) => {
  useNoScroll(open);
   useWrapperLock(open);
  return (
    <Drawer
      open={open}
      onClose={onClose}
      anchor={anchor}
      slotProps={{
        paper: {
          sx: {
            ...(isMobile && {
              height: "100vh",
                            pt: { xs: "60px", md: "0px" },
              maxHeight: "100vh",
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
            }),
          },
        },
      }}
    >
  
          {children}

      
    </Drawer>
  );
};

export default ReusableDrawer;
